import * as moment from 'moment';

export class Transfer {
    id: number;
    date: moment.Moment;
    from: string;
    to: string;
    value: string;
    playerId: number;
    firstName: string;
    lastName: string;
    position: string;
    number: number;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/transfer.model.ts